/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import { xyzSource } from '../core';

/**
 * Layer source to work with Sputnik.ru tile server.
 */
var SPUTNIK_URL_TEMPLATE = 'http://tiles.maps.sputnik.ru/{z}/{x}/{y}.png?apikey={apikey}';
var SPUTNIK_ATTRIBUTIONS = '<a href="http://maps.sputnik.ru/">Спутник</a> ' + '&copy; <a href="http://rt.ru/">Ростелеком</a> ' + '&copy; <a href="https://openstreetmap.org/">Openstreetmap</a>, ' + new Date().getFullYear();

var props = {
  url: {
    type: String,
    default: SPUTNIK_URL_TEMPLATE
  },
  apiKey: {
    type: String
  },
  attributions: {
    type: String,
    default: SPUTNIK_ATTRIBUTIONS
  }
};

var computed = {
  /**
   * @type {string[]}
   */
  urlTokens: function urlTokens() {
    return ['apiKey'];
  }
};

var Source = {
  name: 'vl-source-sputnik',
  mixins: [xyzSource],
  props: props,
  computed: computed
};

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/sputnik-source/index.es.js
// module id = null
// module chunks = 